import { c as _c } from "react/compiler-runtime";
import { PlusOutlined } from '@ant-design/icons';
import { RiInformation2Line } from '@remixicon/react';
import { Tooltip } from 'antd';
import Link from 'next/link';
import SubscriptionToggle from '@/ui/segments/plans/subscription-toggle';
import SubscriptionsCosts from '@/ui/segments/plans/subscriptions-costs';
import { cn } from '@/utils/css-class';
import type { AdvantagesProps, PlanV2 } from '@/types/virtual-lab/pricing';
export default function PlanHeader(t0) {
  const $ = _c(46);
  const {
    plan,
    billingInterval,
    setBillingInterval,
    isCurrentTier,
    hideContactButton,
    testId
  } = t0;
  let t1;
  if ($[0] !== billingInterval || $[1] !== plan.has_subscription || $[2] !== plan.monthly_subscriptions || $[3] !== plan.yearly_subscriptions) {
    t1 = plan.has_subscription ? (billingInterval === "month" ? plan.monthly_subscriptions[0]?.features : plan.yearly_subscriptions[0]?.features) ?? [] : [];
    $[0] = billingInterval;
    $[1] = plan.has_subscription;
    $[2] = plan.monthly_subscriptions;
    $[3] = plan.yearly_subscriptions;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const displayedFeatures = t1;
  let t2;
  if ($[5] !== plan.advantages) {
    t2 = plan.advantages ?? [];
    $[5] = plan.advantages;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const advantages = t2;
  const t3 = `${plan.name}-header`;
  const t4 = isCurrentTier ? "text-white" : "text-primary-9!";
  let t5;
  if ($[7] !== t4) {
    t5 = cn("font-serif text-4xl font-normal", t4);
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== plan.name || $[10] !== t5) {
    t6 = <div className={t5}>{plan.name}</div>;
    $[9] = plan.name;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== billingInterval || $[13] !== isCurrentTier || $[14] !== plan.has_subscription || $[15] !== setBillingInterval) {
    t7 = plan.has_subscription && <SubscriptionToggle billingInterval={billingInterval} setBillingInterval={setBillingInterval} isCurrentTier={isCurrentTier} />;
    $[12] = billingInterval;
    $[13] = isCurrentTier;
    $[14] = plan.has_subscription;
    $[15] = setBillingInterval;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className="flex flex-row items-center justify-between">{t6}{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== plan.has_subtitle || $[21] !== plan.subtitle) {
    t9 = plan.has_subtitle && <div className="text-lg font-normal">{plan.subtitle}</div>;
    $[20] = plan.has_subtitle;
    $[21] = plan.subtitle;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <div className="w-full">{t8}{t9}</div>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== billingInterval || $[27] !== isCurrentTier || $[28] !== plan) {
    t11 = plan.has_subscription && <SubscriptionsCosts billingInterval={billingInterval} plan={plan} isCurrentTier={isCurrentTier} />;
    $[26] = billingInterval;
    $[27] = isCurrentTier;
    $[28] = plan;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11) {
    t12 = <div className="w-full">{t10}{t11}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== hideContactButton || $[34] !== isCurrentTier || $[35] !== plan.has_contact_button || $[36] !== testId) {
    t13 = plan.has_contact_button && !hideContactButton && <div className="w-full"><Link href="mailto:subscription@openbraininstitute.org" data-testid={testId ? `${testId}-contact` : undefined} className={cn("block w-full border py-4 text-center text-base", isCurrentTier ? "border-primary-5 text-white" : "text-primary border-primary")}>Contact Us</Link></div>;
    $[33] = hideContactButton;
    $[34] = isCurrentTier;
    $[35] = plan.has_contact_button;
    $[36] = testId;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== advantages || $[39] !== displayedFeatures) {
    t14 = (displayedFeatures.length > 0 || advantages.length > 0) && <div className="flex flex-col gap-1">{displayedFeatures.map(_temp)}{advantages.map(_temp2)}</div>;
    $[38] = advantages;
    $[39] = displayedFeatures;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t12 || $[42] !== t13 || $[43] !== t14 || $[44] !== t3) {
    t15 = <header id={t3} className="relative flex h-[260px] w-full flex-col justify-between">{t12}{t13}{t14}</header>;
    $[41] = t12;
    $[42] = t13;
    $[43] = t14;
    $[44] = t3;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  return t15;
}
function _temp2(advantage_0) {
  return <div key={`advantage-${advantage_0.title}`} className={cn("flex items-center justify-start gap-2 text-lg font-normal w-full", "text-primary-9")}><PlusOutlined className="size-3" /><div>{advantage_0.title}</div>{advantage_0.tooltip && <div className="ml-auto"><Tooltip title={advantage_0.tooltip} classNames={{
        body: "bg-white! text-primary-9!",
        root: "[&_.ant-tooltip-arrow]:after:bg-white!"
      }}><RiInformation2Line className={cn("size-5 cursor-pointer", "text-primary-9")} /></Tooltip></div>}</div>;
}
function _temp(advantage) {
  return <div key={`feature-${advantage.title}`} className={cn("flex items-center justify-start gap-2 text-lg font-normal w-full", "text-primary-9")}><PlusOutlined className="size-3" /><div>{advantage.title}</div>{advantage.tooltip && <div className="ml-auto"><Tooltip placement="top" title={advantage.tooltip}><RiInformation2Line className={cn("size-5 cursor-pointer", "text-primary-9")} /></Tooltip></div>}</div>;
}